import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import EventsSection from "./components/EventsSection";
import WhyItWorks from "./components/WhyItWorks";
import AboutSection from "./components/AboutSection";
import EnquiryForm from "./components/EnquiryForm";
import ContactSection from "./components/ContactSection";

const IWDPortfolio = () => {
  const [selectedEvents, setSelectedEvents] = useState([]);

  const handleToggleEvent = (eventId) => {
    setSelectedEvents(prev => 
      prev.includes(eventId)
        ? prev.filter(id => id !== eventId)
        : [...prev, eventId]
    );
  };

  const handleRemoveEvent = (eventId) => {
    setSelectedEvents(prev => prev.filter(id => id !== eventId));
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main id="main-content">
        <Hero />
        <EventsSection 
          selectedEvents={selectedEvents} 
          onToggleEvent={handleToggleEvent} 
        />
        <WhyItWorks />
        <AboutSection />
        <EnquiryForm 
          selectedEvents={selectedEvents} 
          onRemoveEvent={handleRemoveEvent} 
        />
        <ContactSection />
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<IWDPortfolio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
